import styled from "styled-components";
import { Omit } from "utils/Omit";
import { ProgressBarProps } from "./types";

export const ProgressBarWrapper = styled("div")<
    Omit<ProgressBarProps, "progress">
>`
    height: ${({ height }) => height || "15px"};
    width: ${({ width }) => width || "200px"};
    border-radius: 10px;
    background-color: #e0e7ec;
`;

export const Progress = styled("div")<{ progress: number; color?: string }>`
    width: ${({ progress }) => progress + "%"};
    background-color: ${({ color }) => color || "#8868EA"};
    height: 100%;
    border-radius: 10px;
    min-width: 0;
    max-width: 100%;
    transition: 0.1s width ease-in-out;
    position: relative;
`;
